/**
 * SEO "Google Reviews": slider arrows + read more / read less.
 */
document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.querySelector('.google-reviews-slider-wrapper');
    if (wrapper) {
        var grid = wrapper.querySelector('.google-reviews-grid');
        var prev = wrapper.querySelector('.prev-btn');
        var next = wrapper.querySelector('.next-btn');
        if (prev && grid) prev.addEventListener('click', function () { grid.scrollBy({ left: -360, behavior: 'smooth' }); });
        if (next && grid) next.addEventListener('click', function () { grid.scrollBy({ left: 360, behavior: 'smooth' }); });
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.btn-read-more');
        if (!btn) return;
        var cardBody = btn.closest('.card-body');
        if (!cardBody) return;
        var shortText = cardBody.querySelector('.text-short');
        var fullText = cardBody.querySelector('.text-full');
        if (!fullText || !shortText) return;
        e.preventDefault();

        var expand = getComputedStyle(fullText).display === 'none';
        shortText.style.display = expand ? 'none' : 'inline';
        fullText.style.display = expand ? 'inline' : 'none';
        btn.innerHTML = expand
            ? 'Read Less <i class="fas fa-chevron-up" style="font-size:11px;"></i>'
            : 'Read More <i class="fas fa-chevron-down" style="font-size:11px;"></i>';
    });
});
